module.exports = __webpack_public_path__ + "img/sad (2).816424f2.png";